(function () {
  var form    = document.querySelector('[data-bff-search-form]');
  var input   = document.querySelector('[data-bff-search-input]');
  var results = document.querySelector('[data-bff-search-results]');
  if (!form || !input || !results) return;

  var timer   = null;
  var current = -1;
  var items   = [];

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(price) {
    var n = parseFloat(price);
    if (isNaN(n)) return '';
    return '$' + n.toFixed(2).replace(/\.00$/, '');
  }

  function renderResults(products, query) {
    results.innerHTML = '';
    current = -1;

    if (!products || products.length === 0) {
      results.innerHTML = '<p class="bff-search-results__empty">No results for &ldquo;' + esc(query) + '&rdquo;</p>';
      results.hidden = false;
      items = [];
      return;
    }

    var frag = document.createDocumentFragment();

    products.forEach(function (p) {
      var a = document.createElement('a');
      a.className = 'bff-search-result';
      a.href = p.url;
      a.setAttribute('tabindex', '-1');

      var imgSrc = p.featured_image && p.featured_image.url
        ? p.featured_image.url.replace('{width}', '96')
        : '';

      a.innerHTML =
        (imgSrc
          ? '<img class="bff-search-result__img" src="' + esc(imgSrc) + '" alt="" width="48" height="48" loading="lazy">'
          : '<div class="bff-search-result__img"></div>') +
        '<div class="bff-search-result__info">' +
          '<div class="bff-search-result__title">' + esc(p.title) + '</div>' +
          (p.vendor ? '<div class="bff-search-result__vendor">' + esc(p.vendor) + '</div>' : '') +
        '</div>' +
        (p.price ? '<span class="bff-search-result__price">' + formatMoney(p.price) + '</span>' : '');

      frag.appendChild(a);
    });

    var footer = document.createElement('a');
    footer.className = 'bff-search-results__footer';
    footer.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
    footer.textContent = 'See all results for \u201c' + query + '\u201d \u2192';
    frag.appendChild(footer);

    results.appendChild(frag);
    results.hidden = false;
    items = Array.from(results.querySelectorAll('.bff-search-result, .bff-search-results__footer'));
  }

  function close() {
    results.hidden = true;
    results.innerHTML = '';
    current = -1;
    items = [];
  }

  function setActive(idx) {
    items.forEach(function (el) { el.classList.remove('is-active'); });
    if (idx >= 0 && idx < items.length) {
      items[idx].classList.add('is-active');
      items[idx].focus();
      current = idx;
    } else {
      current = -1;
      input.focus();
    }
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = input.value.trim();
    if (q.length < 2) { close(); return; }

    timer = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = data.resources && data.resources.results && data.resources.results.products;
          renderResults(products || [], q);
        })
        .catch(function () { close(); });
    }, 200);
  });

  input.addEventListener('keydown', function (e) {
    if (results.hidden) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActive(Math.min(current + 1, items.length - 1));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActive(current > 0 ? current - 1 : -1);
    } else if (e.key === 'Escape') {
      close();
      input.focus();
    }
  });

  results.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActive(Math.min(current + 1, items.length - 1));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActive(current > 0 ? current - 1 : -1);
    } else if (e.key === 'Escape') {
      close();
      input.focus();
    }
  });

  document.addEventListener('click', function (e) {
    if (!form.contains(e.target)) close();
  });

  input.addEventListener('focus', function () {
    if (input.value.trim().length >= 2 && items.length > 0) {
      results.hidden = false;
    }
  });
})();
